import { router } from "@inertiajs/vue3";
import { useEventListener } from "@vueuse/core";
import { onUnmounted, type Ref } from "vue";

/**
 * Asks the person to confirm before they abandon unsaved work while `shouldConfirm` is true.
 *
 * `beforeunload` covers closing the tab or window, reloading, and following a link out of the app;
 * browsers substitute their own generic wording there, so `message` only reaches the person on the
 * in-app path. Inertia visits never fire `beforeunload`, so same-page navigation (nav bar, back
 * links) needs the router guard: returning false from an `inertia:before` handler cancels the visit.
 */
export const useLeaveConfirmation = (message: string, shouldConfirm: Ref<boolean>): void => {
    useEventListener(globalThis, "beforeunload", (event: BeforeUnloadEvent) => {
        if (!shouldConfirm.value) {
            return;
        }

        event.preventDefault();
    });

    onUnmounted(
        router.on("before", () => {
            if (!shouldConfirm.value) {
                return;
            }

            return globalThis.confirm(message);
        }),
    );
};
